<template>
  <div class="tabs" :class="{sticky: fixed}">
    <div class="tabs-hd after-bd-b">
      <div class="tabs-hd-nav">
        <a
          v-for="(item, index) in data"
          href="javascript:;"
          class="nav-item"
          :class="{current: currentIndex === index}"
          @click="_switch(index)"
        >
          {{ item.title }}
        </a>
      </div>
    </div>
    <div class="tabs-bd">
      <div
        v-for="(item, index) in data"
        v-show="currentIndex === index"
        class="tab-pane"
        v-html="item.detail"
      />
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      },
      active: {
        type: Number,
        default: 0
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        currentIndex: this.active
      }
    },
    watch: {
      active(newIndex) {
        this.currentIndex = newIndex
      }
    },
    methods: {
      _switch(index) {
        this.currentIndex = index
      }
    }
  }
</script>

<style>
  @import 'variable';

  .sticky {
    padding-top: 29px;
    .tabs-hd {
      z-index: 2;
      position: absolute;
      top: 40px;
      left: 0;
      width: 100%;
      height: 28px;
      line-height: 28px;
      background-color: var(--white-color);
      font-size: 15px;
      text-align: center;
      overflow-x: scroll;
      -webkit-overflow-scrolling: touch;
      white-space: nowrap;
      &::-webkit-scrollbar {
        width: 0;
        height: 0;
        background-color: transparent;
      }
    }
    .tabs-hd-nav {
      height: 100%;
      .nav-item {
        display: inline-block;
        position: relative;
        max-width: 120px;
        height: 100%;
        margin: 0 10px;
        @apply --text-ellipsis;
        color: var(--thre-color);
      }
      .current {
        &:after {
          z-index: 1;
          content: '';
          border-bottom: 2px solid var(--nine-color);
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
        };
      }
    }
    .tab-pane {
      padding: 20px;
      color: var(--nine-color);
    }
  }
</style>